import React from 'react';
import MainLayout from 'components/layouts/MainLayout';
import PageHeader from 'components/template/global-components/page-header';
import BlogSlider from 'components/artectum/slides/featured-projects-artectum';
import CallToAction from 'components/artectum/common/call-to-action-call';
import AboutContent from './about-content';

const AboutArtectum = () => {
    return (
        <MainLayout>
            <PageHeader headertitle="Acerca de Nosotros" subheader="Artectum" customclass="mb-5"/>
            <AboutContent />
            <BlogSlider title="IDEAS QUE DURAN TODA LA VIDA" sectionClass="pt-70" />
            <CallToAction />
        </MainLayout>
    );
}

export default AboutArtectum;